/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import JurisdictionalStatus from 'linced-app/enums/jurisdictional-status';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class LeaversRoute extends Route {
  // Services
  @service
  store;

  model() {
    // We're not using the parent route's model, as that doesn't automatically refresh
    // if the user navigates between subroutes.  We want to always show the latest data.
    let enrolments = this.store.query('people/enrolment', {
      jurisdictionalStatus: JurisdictionalStatus.PENDING_UNENROLMENT,
      include: 'people',
    });
    let model = {
      enrolments,
      people: enrolments.then((enrolments) => {
        return enrolments.map((enrolment) => {
          return this.store.peekRecord('person', enrolment.personId);
        });
      }),
      uploads: this.store.query('enrolments/unenrolment', {
        isPendingUpload: true,
        jurisdiction: Jurisdiction.NZ_MOE,
      }),
    };

    return hash(model);
  }

  resetController(controller) {
    controller.reset();
  }
}
